import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class PinnedEnterprisesService {
    static pin(enterpriseId) {
        return new Promise((resolve, reject) => {
            axios.post(`${ROOT}enterprises/${enterpriseId}/pin`).then((data) => {
                resolve({ response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    static unpin(enterpriseId) {
        return new Promise((resolve, reject) => {
            axios.delete(`${ROOT}enterprises/${enterpriseId}/pin`).then((data) => {
                resolve({ response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }
}

export default PinnedEnterprisesService;
